/**
 * JOUFFA GLOBAL JS
 * Handles specific interactions like Add to Cart, Sticky Headers, etc.
 */

// Format money logic (Basic replacement for Shopify's format money if not available)
function formatMoney(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || "${{amount}}");

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

/**
 * ADD TO CART (AJAX)
 * Fetches the cart, adds items, and opens the drawer if present.
 */
async function addToCart(formData) {
    const btn = document.querySelector('.jouffa-add-to-cart-button');
    const stickyBtn = document.querySelector('#jouffa-sticky-bar .jouffa-twitch-button'); // Mobile sticky only
    const originalText = btn ? btn.innerHTML : 'ADD TO CART';

    // Set Loading State
    if (btn) btn.innerHTML = 'ADDING...';
    if (stickyBtn) stickyBtn.innerHTML = '...';

    try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: "POST",
            body: formData
        });

        if (response.ok) {
            const item = await response.json();

            // Success feedback
            if (btn) btn.innerHTML = 'ADDED!';
            if (stickyBtn) stickyBtn.innerHTML = 'ADDED';

            // Update Cart Drawer (If it exists) or Redirect
            // For now, we'll try to trigger a drawer update event if the theme supports it,
            // otherwise, we might just redirect to cart or show a notification.

            // Generic event for other scripts to listen to
            document.dispatchEvent(new CustomEvent('cart:item-added', { detail: item }));

            // Fetch fresh cart data to update counts
            updateCartCount();

            setTimeout(() => {
                if (btn) btn.innerHTML = originalText;
                if (stickyBtn) stickyBtn.innerHTML = 'ADD';
            }, 2000);

        } else {
            console.error('Error adding to cart:', response);
            if (btn) btn.innerHTML = 'ERROR';
            alert("There was an issue adding this item to your cart.");
        }
    } catch (error) {
        console.error('Fetch error:', error);
        if (btn) btn.innerHTML = 'ERROR';
    }
}

/**
 * UPDATE CART COUNT
 */
async function updateCartCount() {
    try {
        const res = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await res.json();

        // Update all count badges
        document.querySelectorAll('.jouffa-cart-count').forEach(el => {
            el.innerText = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
    } catch (e) {
        console.error('Error updating cart count', e);
    }
}

/**
 * PRODUCT IMAGE SWAPPER
 */
function changeMainImage(src, thumbnail) {
    const mainImage = document.getElementById('JouffaMainImage');
    if (mainImage) {
        mainImage.style.opacity = 0;
        setTimeout(() => {
            mainImage.src = src;
            mainImage.style.opacity = 1;
        }, 200);
    }

    // Update Active State
    document.querySelectorAll('.jouffa-thumbnail').forEach(el => el.classList.remove('active'));
    if (thumbnail) thumbnail.classList.add('active');
}

// INITIALIZATION
document.addEventListener('DOMContentLoaded', () => {
    updateCartCount();
});

/**
 * VARIANT SELECTOR LOGIC
 * matches selected options to a variant ID
 */
function onVariantChange() {
    const variantData = JSON.parse(document.getElementById('ProductVariantsJson').textContent);
    const selectors = document.querySelectorAll('.single-option-selector');

    // 1. Build Array of currently selected values
    // Note: options are 1-indexed (option1, option2...)
    let selectedOptions = [];
    selectors.forEach(sel => selectedOptions.push(sel.value));

    // 2. Find Matching Variant
    const matchedVariant = variantData.find(variant => {
        return selectedOptions.every((val, index) => {
            return variant.options[index] === val;
        });
    });

    // 3. Update UI
    const addToCartBtn = document.querySelector('.jouffa-add-to-cart-button');
    const priceDisplay = document.querySelector('.jouffa-product-price-large');
    const hiddenInput = document.querySelector('input[name="id"]');

    if (matchedVariant) {
        // Update Hidden ID
        if (hiddenInput) hiddenInput.value = matchedVariant.id;

        // Update Price
        if (priceDisplay) {
            let priceHTML = formatMoney(matchedVariant.price, "${{amount}}");
            if (matchedVariant.compare_at_price > matchedVariant.price) {
                priceHTML += ` <span style="text-decoration: line-through; color: #666; font-size: 0.6em; margin-left: 10px;">${formatMoney(matchedVariant.compare_at_price, "${{amount}}")}</span>`;
            }
            priceDisplay.innerHTML = priceHTML;
        }

        // Update Button State
        if (matchedVariant.available) {
            addToCartBtn.innerHTML = 'ADD TO CART';
            addToCartBtn.disabled = false;
            addToCartBtn.style.backgroundColor = ''; // Reset
            addToCartBtn.style.cursor = 'pointer';
        } else {
            addToCartBtn.innerHTML = 'SOLD OUT';
            addToCartBtn.disabled = true;
            addToCartBtn.style.backgroundColor = '#333';
            addToCartBtn.style.cursor = 'not-allowed';
        }

        // Update URL (Optional but good practice)
        const newUrl = new URL(window.location);
        newUrl.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState(null, '', newUrl);

    } else {
        // Unavailable Combination
        addToCartBtn.innerHTML = 'UNAVAILABLE';
        addToCartBtn.disabled = true;
        addToCartBtn.style.backgroundColor = '#333';
        addToCartBtn.style.cursor = 'not-allowed';
    }
}
